import React, { Component } from 'react';
import NotificationContainer from '../../notification/containers/NotificationContainer'

class App extends Component {
    render() {
        return (
            <div className="fullheight">
            	<NotificationContainer />
                <div>{this.props.children}</div>
            </div>
        )
    }
}

export default App


// WEBPACK FOOTER //
// ./src/core/components/AppComponent.js